<script setup>
import { defineProps } from 'vue';
defineProps({
  image: String,
  title: String,
  color: {
    type: String,
    default: 'Standart' // Eğer isim gelmezse yazacak olan varsayılan metin
  }
})
</script>

<template>
  <div class="product-item">
    <div class="img-container">
      <img :src="image" :alt="title" loading="lazy" />
    </div>
    
    <div class="product-info">
      <h3 class="product-title">{{ title }}</h3>
      <div class="product-footer">
        <span class="color-dot"></span>
        <span class="color-name">{{ color }}</span> </div>
    </div>
  </div>
</template>

<style scoped>
.product-item {
  width: 100%;
  cursor: pointer;
}

.img-container {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4; /* Perdeler için dikey oran daha şık durur */
  background: #f7f7f7;
  overflow: hidden;
  border-radius: 4px; /* Çok hafif bir yuvarlaklık, kutu hissi vermez */
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 1.2s cubic-bezier(0.19, 1, 0.22, 1);
}

.overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(45, 90, 39, 0.1); /* Çok hafif yeşil bir dokunuş */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.4s ease;
}

.overlay span {
  color: white;
  background: #1a1a1a;
  padding: 10px 20px;
  font-size: 0.7rem;
  letter-spacing: 2px;
  font-weight: 700;
}

.product-info {
  padding: 15px 0;
}

.product-category {
  color: #2d5a27; /* Senin yeşilin */
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 2px;
  display: block;
  margin-bottom: 5px;
}

.product-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  text-transform: capitalize;
}

.product-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.color-dot {
  width: 8px;
  height: 8px;
  background: #d1d1d1; /* Gri detay */
  border-radius: 50%;
}

.color-name {
  font-size: 0.75rem;
  color: #888;
}

/* Hover Efektleri */
.product-item:hover img {
  transform: scale(1.05);
}

.product-item:hover .overlay {
  opacity: 1;
}

.product-item:hover .product-title {
  color: #2d5a27;
}
</style>